import { Company } from "app/company/company.model";
import { ITermsDetail } from "./terms-detail.interface";

export class OrganizationTermsTranslation {
  constructor(
    private locale: string,
    private company: Company | null,
    private fcl: ITermsDetail,
    private lcl: ITermsDetail,
    private air: string,
    private ltl: string,
    private ftl: string,
    private ptl: string,
    private manual: string,
    private multi: string,
  ) {}

  public getLocale(): string {
    return this.locale;
  }

  public getCompany(): Company | null {
    return this.company;
  }

  public getFcl(): ITermsDetail {
    return this.fcl;
  }

  public setFcl(fcl: ITermsDetail): void {
    this.fcl = fcl;
  }

  public getLcl(): ITermsDetail {
    return this.lcl;
  }

  public setLcl(lcl: ITermsDetail): void {
    this.lcl = lcl;
  }

  public getAir(): string {
    return this.air;
  }

  public setAir(air: string): void {
    this.air = air;
  }

  public getLtl(): string {
    return this.ltl;
  }

  public setLtl(ltl: string): void {
    this.ltl = ltl;
  }

  public getFtl(): string {
    return this.ftl;
  }

  public setFtl(ftl: string): void {
    this.ftl = ftl;
  }

  public getPtl(): string {
    return this.ptl;
  }

  public setPtl(ptl: string): void {
    this.ptl = ptl;
  }

  public getManual(): string {
    return this.manual;
  }

  public setManual(manual: string): void {
    this.manual = manual;
  }

  public getMulti(): string {
    return this.multi;
  }

  public setMulti(multi: string): void {
    this.multi = multi;
  }

  public toJSON(): object {
    return {
      locale: this.locale,
      company: this.company?.id ?? null,
      fcl: this.fcl,
      lcl: this.lcl,
      air: this.air,
      ltl: this.ltl,
      ftl: this.ftl,
      ptl: this.ptl,
      manual: this.manual,
      multi: this.multi,
    };
  }
}
